// @flow
import styled from "styled-components"

export const Wrap = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`

export const IconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 7rem;
  height: 2rem;
  background: ${(props) => props.theme.color.lightGray};
  padding: 1.5rem;
  border-radius: 5rem;
`

export const Text = styled.p`
  color: ${(props) => props.theme.color.primaryAccent};
  font-weight: 500;
`;



// WEBPACK FOOTER //
// ./src/components/PlanIcon/styled.js